var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{class:_vm.className,attrs:{"type":_vm.btntype,"size":_vm.size,"disabled":_vm.disabled,"round":_vm.round,"plain":_vm.plain,"circle":_vm.circle,"autofocus":_vm.autofocus,"icon":_vm.iconName,"native-type":_vm.nativeType,"loading":_vm.loading},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.title)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }